import { render, staticRenderFns } from "./queries.vue?vue&type=template&id=cc340ce0"
import script from "./queries.vue?vue&type=script&lang=js"
export * from "./queries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports